/**
 * Identify Event Properties
 *
 * Similar to the Segment/RudderStack properties at:
 * https://segment.com/docs/connections/spec/identify/#traits
 */

export let Gender = /*#__PURE__*/function (Gender) {
  Gender["MALE"] = "MALE";
  Gender["FEMALE"] = "FEMALE";
  Gender["OTHER"] = "OTHER";
  return Gender;
}({});